module.exports = require("@braintree/browser-detection");